import turboInit from "../utils/turbo-init"

turboInit(() => {
  const checkboxDropdowns = document.querySelectorAll(`.dropdown-checkboxes`)

  checkboxDropdowns.forEach((dropdown) => {
    const panel = dropdown.querySelector(`.dropdown-checkboxes__panel`)
    const button = dropdown.querySelector(`.dropdown-checkboxes__button`)
    const options = dropdown.querySelectorAll(`.dropdown-checkboxes__option`)
    const currentValue = button.querySelector(`.dropdown-checkboxes__value`)

    function handleClick(e) {
      const target = e.target

      if (!button.contains(target) && !panel.contains(target)) {
        closeDropdown()
      }
    }

    function handleKeyup(e) {
      const key = e.key

      if (key === `Escape`) {
        closeDropdown()
      }
    }

    function expandDropdown() {
      // expand
      panel.classList.add(`dropdown-checkboxes__panel--open`)
      button.ariaExpanded = `true`
    }

    function closeDropdown() {
      // close
      panel.classList.remove(`dropdown-checkboxes__panel--open`)
      button.ariaExpanded = `false`
    }

    document.addEventListener(`click`, handleClick)
    document.addEventListener(`keyup`, handleKeyup)

    button.addEventListener(`click`, () => {
      const isExpanded = button.ariaExpanded === `true`

      if (!isExpanded) {
        dropdown.classList.add(`-has-value`)

        expandDropdown()
      } else {
        if (!currentValue.textContent) {
          dropdown.classList.remove(`-has-value`)
        }

        closeDropdown()
      }
    })

    options.forEach((option) => {
      option.addEventListener(`change`, () => {
        updateSelected({ options, currentValue, dropdown })
      })
    })

    updateSelected({ options, currentValue, dropdown })
  })
})

function updateSelected({ options, currentValue, dropdown }) {
  const selectedItems = []
  options.forEach((option) => {
    const parent = option.parentNode
    const textContent = parent.textContent
    const checked = option.checked

    if (checked) {
      selectedItems.push(textContent)
    }
  })

  if (selectedItems.length > 0) {
    dropdown.classList.add(`-has-value`)
  } else {
    dropdown.classList.remove(`-has-value`)
  }

  currentValue.textContent = selectedItems.join(`, `)
}
